import styled from 'styled-components'

import { media } from '../../../styles/media'

export const BucketListButton = styled.button.attrs(
  ({ isActive, ...props }: { isActive?: boolean; 'aria-label'?: string }) => {
    const label =
      props['aria-label'] ||
      (isActive ? 'Remove from bucket list' : 'Add to bucket list')

    return {
      type: 'button' as const,
      'aria-label': label,
    }
  }
)<{
  left?: boolean
  isActive?: boolean
  rounded?: boolean
}>`
  position: absolute;
  appearance: none;
  border: none;
  outline: none;
  background: transparent;

  width: 55px;
  height: 55px;

  margin: 0;

  position: absolute;
  top: 0;

  ${({ rounded }) =>
    rounded !== false &&
    `
    border-radius: 6px;
  `}

  ${({ left }) =>
    left
      ? `
    left: 0;
  `
      : `
    right: 0;
  `}

  color: white;

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    width: 32px;
    height: 32px;

    transition: color 150ms ease-out;

    &:first-child {
      color: rgba(0, 0, 0, 0.3);
    }
  }

  ${({ isActive }) =>
    isActive &&
    `
    svg:first-child {
      color: #ebcec9;
    }
  `}
`

export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.default};
  font-weight: 100;
`

export const HeaderPlaceholder = styled.div<{ heightPx?: number }>`
  display: none;
  height: ${({ heightPx = 64 }) => heightPx}px;
  margin-bottom: 16px;

  ${media.md`
    display: block;
  `}
`

export const Image = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
`

export const Details = styled.div`
  flex: 1;
  line-height: 1.6;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const TitleWrapper = styled.div`
  white-space: normal;

  padding-right: 12px;
`

export const HeartIcon = styled.i.attrs({
  className: 'icon icon-bucketlist-heart-on',
})`
  margin-right: 0 !important;
`

export const Location = styled.div<{ compact?: boolean }>`
  color: ${({ theme }) => theme?.['-ds-neutral-600']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxs']?.['font-size']?.value};
  font-weight: 300;
  line-height: 1.4;
  margin-bottom: ${({ compact }) => (compact ? '4px' : '6px')};
`

export const Title = styled.h3<{ compact?: boolean }>`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  line-height: 1.4;
  font-weight: 400;
  margin-bottom: ${({ compact }) => (compact ? '4px' : '6px')};
`

export const Media = styled.div`
  position: relative;
`

export const Content = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: ${({ compact }) => (compact ? 'column' : 'row')};
  justify-content: space-between;
  text-align: left;
  padding: ${({ compact }) => (compact ? '8px 0' : '16px 0 32px 0')};
`

export const Slide = styled.div`
  height: 100%;
  background-color: #ddd;
  overflow: hidden;
`
